import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  faPlus,
  faCubes,
  faPlane,
  faEllipsisV,
  faCheck,
  faTimes,
  faLongArrowAltRight,
} from '@fortawesome/free-solid-svg-icons';
import { faEdit, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import {
  NotificationService,
  ModalService,
  LoadingScreenService,
  ConfirmService,
  FormGenerator,
  AreaBoxMenuItem,
  QueryBuilderFormType,
  QueryBuilderService,
} from '@giglio-com/ng-libraries/dist';
// import { TableData } from '@giglio-com/ng-libraries/lib/table/table.model';
import { TestModalComponent } from '../../components/test-modal/test-modal.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ConfirmActions } from '@giglio-com/ng-libraries/dist/lib/confirm/confirm.component';
import { TranslocoService } from '@ngneat/transloco';
import flatpickr from 'flatpickr';
import { english } from 'flatpickr/dist/l10n/default';
import { Italian } from 'flatpickr/dist/l10n/it';
import { Spanish } from 'flatpickr/dist/l10n/es';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index';
import * as moment from 'moment';

@Component({
  selector: 'app-test-component',
  templateUrl: './test-component.component.html',
  styleUrls: ['./test-component.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestComponentComponent implements OnInit, AfterViewInit {
  public faPlus = faPlus;
  public faEdit = faEdit;
  public faEllipsis = faEllipsisV;
  public faDelete = faTrashAlt;
  public faCheck = faCheck;
  public faClose = faTimes;
  public arrowRight = faLongArrowAltRight;

  public breadcrumbs = [
    {
      key: 'Admin',
      href: '/admin',
    },
    {
      key: 'Dashboard',
      href: '/dashboard',
    },
  ];

  public actions = [
    {
      label: 'Inserisci un nuovo utente',
      callback: this.onInsertClick.bind(this),
      icon: faPlus,
    },
  ];

  public items: any;
  public progress = 650;
  public groups: any;
  public formData!: FormGenerator;

  public dataTable = [
    {
      1: 'placeholder 1',
      2: 'placeholder 2',
      3: 'placeholder 3',
      4: 'placeholder 4',
      5: 'placeholder 5',
      6: 'placeholder 6',
    },
    {
      1: 'placeholder 1',
      2: 'placeholder 2',
      3: 'placeholder 3',
      4: 'placeholder 4',
      5: 'placeholder 5',
      6: 'placeholder 6',
    },
    {
      1: 'placeholder 1',
      2: 'placeholder 2',
      3: 'placeholder 3',
      4: 'placeholder 4',
      5: 'placeholder 5',
      6: 'placeholder 6',
    },
    {
      1: 'placeholder 1',
      2: 'placeholder 2',
      3: 'placeholder 3',
      4: 'placeholder 4',
      5: 'placeholder 5',
      6: 'placeholder 6',
    },
    {
      1: 'placeholder 1',
      2: 'placeholder 2',
      3: 'placeholder 3',
      4: 'placeholder 4',
      5: 'placeholder 5',
      6: 'placeholder 6',
    },
  ];

  //Area Box Menu
  public menu: AreaBoxMenuItem[] = [
    {
      name: 'Ricezione',
      icon: faPlane,
      children: [
        {
          name: 'Spedizioni in arrivo',
          permalink: '/logistic/incoming-shipping',
          icon: faCubes,
        },
      ],
    },
    {
      name: 'Evasione',
      icon: faPlane,
      children: [
        {
          name: 'Crea spedizione',
          permalink: '/logistic/shipping',
          icon: faCubes,
        },
        {
          name: 'Ordini da spedire',
          permalink: '/logistic/direct-orders',
          icon: faCubes,
        },
        {
          name: 'Ordini da evadere',
          permalink: '/logistic/orders-to-be-proceded',
          icon: faCubes,
        },
        {
          name: 'Crea DDT',
          permalink: '/logistic/dn-create',
          icon: faCubes,
        },
        {
          name: 'Archivia AWB',
          permalink: '/logistic/archiving-awb',
          icon: faCubes,
        },
      ],
    },
    {
      name: 'Reportistica',
      icon: faPlane,
      children: [
        {
          name: 'DDT',
          permalink: '/logistic/dn-out',
          icon: faCubes,
        },
        {
          name: 'AWB archiviati',
          permalink: '/logistic/archivied-awb',
          icon: faCubes,
        },
        {
          name: 'AWBs',
          permalink: '/logistic/awb',
          icon: faCubes,
        },
      ],
    },
    {
      name: 'Impostazioni',
      icon: faPlane,
      children: [
        {
          name: 'Metodi di spedizione',
          permalink: '/logistic/shipment-cost',
          icon: faCubes,
        },
        {
          name: 'Metodi di reso',
          permalink: '/logistic/return-costs',
          icon: faCubes,
        },
      ],
    },
  ];

  backred(): object {
    return { 'background-color': 'red' };
  }

  public filters: any;
  public selectData = [
    { value: '1', key: 'Placeholder 1' },
    { value: '2', key: 'Placeholder 2', styles: this.backred() },
    { value: '3', key: 'Placeholder 3' },
  ];

  public selectDataMultiple = [
    { value: '1wd3', key: 'Placeholder 1' },
    { value: '22d23', key: 'Placeholder 2' },
    { value: '323d2', key: 'Placeholder 3' },
    { value: '788', key: 'Placeholder 2' },
    { value: '967', key: 'Placeholder 3' },
  ];

  public radioForm: any;

  public chipsList = ['Apple', 'banana', 'orange', 'kiwi'];
  public confirmActions: ConfirmActions = { confirm: 'confirm', cancel: 'cancel' };

  public rangeForm: FormGroup;

  public localeList = [
    { code: 'it', locale: Italian },
    { code: 'en', locale: english },
    { code: 'es', locale: Spanish },
  ];
  currentLocale: any = Italian;
  // currentMonth = moment();
  public testMonth = new Date();
  @ViewChild('flatpickr') el!: ElementRef;
  instance: any;

  constructor(
    private notification: NotificationService,
    private modal: ModalService,
    private loadingScreen: LoadingScreenService,
    private confirm: ConfirmService,
    private queryBuilder: QueryBuilderService,
    private fb: FormBuilder,
    private translocoService: TranslocoService
  ) {
    this.formData = {
      groups: [
        {
          fields: [
            {
              type: 'text',
              field: 'name',
              label: 'Nome',
              validation: ['required'],
            },
            {
              type: 'text',
              field: 'email',
              label: 'Email',
              validation: ['required', 'email'],
            },
            {
              type: 'ng-select',
              field: 'roles',
              label: 'Ruolo',
              multiple: true,
              default: null,
              data: [
                { value: '1', key: 'Admin' },
                { value: '2', key: 'User' },
              ],
              validation: ['required'],
            },
            {
              type: 'password',
              field: 'password',
              label: 'Password',
              validation: ['required'],
            },
            {
              type: 'toggle',
              field: 'check',
              label: 'toggle',
              validation: ['required'],
            },
          ],
        },
      ],
    };

    this.rangeForm = new FormGroup({
      month: new FormControl(new Date(this.testMonth)),
    });
  }

  s_button: boolean = true;

  onValueChange(event: any) {
    console.log('value changed', event);
  }

  ngOnInit(): void {
    this.radioForm = this.fb.group({
      test: [''],
    });

    this.filters = {
      properties: [
        {
          label: 'Nome',
          key: 'name',
          type: QueryBuilderFormType.Text,
        },
        {
          label: 'Predefinito',
          type: QueryBuilderFormType.Select,
          key: 'isDefault',
          value: null,
          operator: 'EQ',
          selectData: this.selectData,
        },
      ],
    };

    this.translocoService.selectTranslateObject(this.confirmActions).subscribe((value) => {
      this.confirmActions.confirm = value[0];
      this.confirmActions.cancel = value[1];
    });

    const localLang = localStorage.getItem('translocoLang');
    this.currentLocale = this.localeList.find((f) => f.code === localLang)?.locale;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.instance = flatpickr(this.el.nativeElement, {
        locale:
          this.localeList[
            this.localeList.findIndex((lang: any) =>
              lang.code == localStorage.getItem('translocoLang') ? localStorage.getItem('translocoLang') : 'it'
            )
          ].locale,
        defaultDate: moment().toISOString(),
        onChange: (selectedDates, dateStr, instance) => alert('onchange'),

        plugins: [
          monthSelectPlugin({
            shorthand: true,
            dateFormat: 'M Y',
          }),
        ],
      });
    }, 100);
  }

  openNotification() {
    this.notification.toggle('This is a notification', 'error');
  }

  onOpenModal(data?: any) {
    this.modal.open({
      component: TestModalComponent,
      inputs: { ...data, confirmText: 'Conferma', cancelText: 'Annulla' },
    });
  }

  openLoading() {
    this.loadingScreen.start();
    setTimeout(() => {
      this.loadingScreen.stop();
    }, 5000);
  }

  onConfirm() {
    this.confirm.show('Sei sicuro di voler continuare?', this.confirmActions).then();
  }

  onSubmitForm($event: Event) {}

  datePickerOptions() {
    return {
      altInput: false,
      dateFormat: 'd-m-Y',
      locale:
        this.localeList[
          this.localeList.findIndex((lang: any) =>
            lang.code == localStorage.getItem('translocoLang') ? localStorage.getItem('translocoLang') : 'it'
          )
        ].locale,
      // onChange: (selectedDate: any) => {
      //   const [from, to] = selectedDate;
      //   if (from && to) {
      //     this.rangeForm.get('dateFrom')?.setValue(selectedDate[0]);
      //     this.rangeForm.get('dateTo')?.setValue(selectedDate[1]);
      //     console.log(this.rangeForm.value);
      //   }
      // },
    };
  }

  onInsertClick() {
    console.log('This is an action.');
  }

  // getSkip() {
  //   this.queryBuilder.getSkip();
  // }
  checkValue() {
    console.log(this.radioForm.value);
  }

  selectedMonth() {
    console.log(this.testMonth);
  }
  log(log: any) {
    console.log(log);
  }
}
